<form style="text-align: left; margin-bottom: 15px;" novalidate [formGroup]="globalData.ristoranteAddForm">

    <input formControlName="data" [class.error1]="!globalData.ristoranteAddForm.controls.data.valid && globalData.ristoranteAddForm.controls.data"
        autocomplete="off" class="form-control datepicker-custom" (click)="datePickerIdAdd.toggle()" placeholder="gg-mm-aaaa"
        [(ngModel)]="globalData.dataAddRistorante" ngbDatepicker #datePickerIdAdd="ngbDatepicker">
    <div no-lines *ngIf="globalData.ristoranteAddForm.get('data').hasError('required')  && globalData.ristoranteAddForm.get('data').touched">
        <div style="color: red !important" class="error" *ngIf="globalData.ristoranteAddForm.get('data').hasError('required') && globalData.ristoranteAddForm.get('data').touched">
            Selezionare il giorno della prenotazione
        </div>
    </div>
</form>